<template>
  <div>
    <app-cells>
      <div class="date-picker-wrapper">
        <VueCtkDateTimePicker
          id="date_picker_balance"
          class="custom-date-time-picker custom-date-time-picker--range"
          v-model="dates"
          :custom-shortcuts="custom_shortcuts"
          shortcut="last30Days"
          @is-hidden="onIsHiddenPicker"
          format="YYYY-MM-DD"
          formatted="ll"
          label="Select dates"
          color="#77b017"
          button-color="#77b017"
          overlay
          no-header
          no-label
          locale="en"
          range
          noClearButton
        />
        <div v-if="date_picker_error" class="date-picker-wrapper__error">Choose an end date</div>
      </div>
    </app-cells>
    <div class="charts-grid">
      <highcharts :options="chart_options" />
    </div>
    <v-client-table
      :data="table.items"
      :columns="table.columns"
      :options="table.options"
      class="table-default"
    >
      <template #h__event_id><div class="table-default__left">Event</div></template>
      <template #created_at="{ row }">
        {{ dateTimeFormat(row.created_at) }}
      </template>
      <template #event_id="{ row }">
        <div class="table-default__left">
<!--          <router-link-->
<!--            v-if="row.event"-->
<!--            :to="{ name: `product-storage-${row.event.toLowerCase()}-detail`, params: { id: row.event_id } }"-->
<!--            class="table-default__link-border"-->
<!--          >-->
<!--            {{ row.event }} (ID: {{ row.event_id }})-->
<!--          </router-link>-->
          <span v-if="row.event">{{ row.event }} (ID: {{ row.event_id }})</span>
          <span v-else>-</span>
        </div>
      </template>
      <template #value="{ row }">
        {{ row.value.toLocaleString() }} km
      </template>
      <template #void="{ row }">
          <span
            class="status-tag"
            :style="{ 'backgroundColor': row.void ? '#f0c427' : '#5f5f5f' }"
          >
            {{ row.void ? 'Yes' : 'No' }}
          </span>
      </template>
      <template #reported_by="{ row }">
        <div class="table-default__controls">
          <div class="table-default__photo">
            <img
              :src="getUserAvatar(row.reported_by.crop.crop_url)" alt="Avatar"
              v-tooltip="{ content: `${row.reported_by.first_name} ${row.reported_by.last_name || ''}`, placement: 'top-start', offset: 10 }"
            >
          </div>
        </div>
      </template>
    </v-client-table>
  </div>
</template>

<script>
import { getCarManagementOdometerHistory } from '@/http'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import { Chart } from 'highcharts-vue'
import { format, parseISO } from 'date-fns'

export default {
  name: 'CarManagementCarsDetailOdometer',
  components: { highcharts: Chart, VueCtkDateTimePicker },
  data() {
    return {
      custom_shortcuts: [
        { key: 'last30Days', label: 'Last 30 days', value: 30 },
        { key: 'last60Days', label: 'Last 60 days', value: 60 },
        { key: 'last90Days', label: 'Last 90 days', value: 90 },
        { key: 'thisYear', label: 'This year', value: 'year' },
      ],
      date_picker_error: null,
      dates: null,
      chart_options: {
        accessibility: {
          enabled: false,
        },
        CSSObject: {
          fontFamily: 'regular',
          fontSize: '6.2em',
        },
        chart: {
          type: 'spline'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            }
          }
        },
        series: []
      },
      table: {
        items: [],
        columns: ['created_at', 'event_id', 'value', 'void', 'reported_by'],
        options: {
          headings: {
            'created_at': 'Date',
            'event_id': 'Event',
            'value': 'Odometer',
            'void': 'Void',
            'reported_by': 'Reported by',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 1000,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
  created() {
    this.$nextTick(() => {
      this.fetchItems()
    })
  },
  methods: {
    fetchItems() {
      getCarManagementOdometerHistory(this.$route.params.id, {date_after: this.dates.start, date_before: this.dates.end})
        .then(response => {
          this.chart_options.xAxis.categories = response.data.graph.categories
          this.chart_options.series = response.data.graph.series
          this.table.items = response.data.table
        })
    },
    onIsHiddenPicker() {
      if (this.dates.hasOwnProperty('start') &&
        this.dates.start &&
        this.dates.hasOwnProperty('end') &&
        this.dates.end) {
        this.date_picker_balance_error = false
        this.fetchItems()
      } else this.date_picker_balance_error = true
    },
    dateTimeFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy HH:mm') : '-'
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
  }
}
</script>

<style lang="sass">
.date-picker-wrapper
  position: relative

.date-picker-wrapper__error
  position: absolute
  bottom: -18px
  color: $color-error
  font-size: 12px
</style>
